import { Divider, List, ListItem } from "@chakra-ui/react";
import type { FC } from "react";

import { Text } from "@equidefi/ui";
import { Icon } from "@equidefi/ui/icon";

type AccreditationRequirementsProps = {
  summary: string;
  requirements: string[];
};

export const AccreditationRequirements: FC<AccreditationRequirementsProps> = ({ summary, requirements }) => (
  <>
    <Text fontSize="sm" mb={2.5}>
      {summary}
    </Text>
    <Divider mb={2.5} />
    <Text fontWeight="bold" mb={2.5}>
      Requirements
    </Text>
    <List spacing={2.5} fontSize="sm" mb={4}>
      {requirements.map((requirement) => (
        <ListItem key={requirement} display="flex">
          <Icon.Check size="18px" color="equidefi.green" style={{ flexShrink: 0, marginTop: 2, marginRight: 8 }} />
          {requirement}
        </ListItem>
      ))}
    </List>
  </>
);
